"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfficeType = void 0;
var OfficeType;
(function (OfficeType) {
    OfficeType["unknown"] = "unknown";
    OfficeType["wpp"] = "wpp";
    OfficeType["wps"] = "wps";
    OfficeType["et"] = "et";
    OfficeType["pdf"] = "pdf";
    OfficeType["otl"] = "otl";
    OfficeType["ksheet"] = "ksheet";
    OfficeType["db"] = "db";
    OfficeType["form"] = "form";
    OfficeType["kw"] = "kw";
    OfficeType["pom"] = "pom";
    OfficeType["pof"] = "pof";
    OfficeType["img"] = "img";
    OfficeType["ckt"] = "ckt";
})(OfficeType || (exports.OfficeType = OfficeType = {}));
